var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76104 7.02944L7.0795 10.1779C7.51884 10.5947 7.51884 11.2705 7.0795 11.6874C6.64017 12.1042 5.92785 12.1042 5.48851 11.6874L0.715544 7.15893C0.615159 7.06369 0.537711 6.95493 0.4832 6.83882C0.191151 6.64602 0 6.32522 0 5.96207C0 5.57349 0.218856 5.23342 0.545997 5.04674C0.592412 4.97343 0.648927 4.90427 0.715544 4.84107L5.48851 0.312624C5.92785 -0.104208 6.64017 -0.104208 7.0795 0.312624C7.51884 0.729456 7.51884 1.40527 7.0795 1.82211L3.84099 4.89471H16.875C17.4963 4.89471 18 5.37258 18 5.96207C18 6.55156 17.4963 7.02944 16.875 7.02944H3.76104Z",
    fill: "#162056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3c9f104b789f69d6a7146906add0cd28.svg";
export { ForwardRef as ReactComponent };